import HttpError from './HttpError';

export default class SlugExistsError extends HttpError {}
